import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  ButtonComponent,
  ButtonConfig,
  ButtonVariant,
} from "../components/core/button/button.component";

@Component({
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: "./entity-management-layout.component.html",
  selector: "entity-management-layout",
})
export class EntityManagementLayoutComponent {
  @Input() title!: string;
  @Input() message!: string;
  @Input() saveDisabled = false;
  @Input() showTopButtons = false;
  @Input() showBottomButtons = true;
  @Input() isNewEntity = true;
  @Input() contentDescription!: string;
  @Input() hideSave = false;
  @Input() showSummary: boolean = false;
  @Output() saveClicked: EventEmitter<any> = new EventEmitter();
  @Output() cancelClicked: EventEmitter<any> = new EventEmitter();

  buttonVariant = ButtonVariant;
  saveBtnConfig: ButtonConfig = {
    variant: ButtonVariant.SECONDARY,
    text: "Save",
  };

  ngOnChanges() {
    if (this.showSummary) {
      this.saveBtnConfig.text = "Continue";
    }
  }

  onSaveClicked() {
    if (!this.saveDisabled) {
      this.saveClicked.emit();
    }
  }

  onCancelClicked() {
    this.cancelClicked.emit();
  }
}
